module.exports = __webpack_public_path__ + "media/img/frontend_application/country/id-2e2be0dff0f01d5444cc0416f24be44a.jpg";